@if (admin(); as adminData) {
  <div class="admin-profile-container">
    <!-- Header Card -->
    <div class="profile-header">
      <div class="header-content">
        <div class="profile-avatar-custom">
          {{ getInitials() }}
        </div>
        <div class="header-info">
          <div class="d-flex align-items-center flex-wrap gap-3 mb-2">
            <h2 class="user-name">{{ getFullName() }}</h2>
            <p-tag
              [value]="getRoleDisplay(adminData.user.role)"
              [styleClass]="getRoleSeverity(adminData.user.role)"
              [icon]="getRoleIcon(adminData.user.role)"
              styleClass="role-badge"/>
          </div>
          <div class="user-email">
            <i class="pi pi-envelope mr-2"></i>
            {{ adminData.user.email }}
          </div>
        </div>
      </div>
    </div>
  </div>
}

